"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTracking;
var _react = require("react");
var _trackingStub = _interopRequireDefault(require("./trackingStub"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function useTracking() {
  const [trackingInfo, setTrackingInfo] = (0, _react.useState)({
    tracking: _trackingStub.default,
    isTrackingInitialized: false
  });
  (0, _react.useEffect)(() => {
    const onTrackingReady = callback => {
      if (window && window.tracking && window.tracking.page) {
        callback();
      } else {
        window.addEventListener("trackingReady", callback);
        return () => {
          window.removeEventListener("trackingReady", callback);
        };
      }
    };
    if (window) {
      return onTrackingReady(() => {
        trackingInfo.tracking.setTrackingAndReplay(window.tracking);
        setTrackingInfo({
          tracking: trackingInfo.tracking,
          isTrackingInitialized: true
        });
      });
    }
  }, []);
  return trackingInfo;
}